class HeatCalculator {
	unite_calc;
	brand;
	button = document.querySelector("#heat_calculate");
	unite = document.querySelector("#unite");
	width = document.querySelector("#width");
	height = document.querySelector("#height");
	depth = document.querySelector("#depth");
	cubic_feet = document.querySelector("#total_feet");
	cold_sf_ft = document.querySelector("#cold_sf_ft");
	title_placeholder = document.querySelector("[data_title_placeholder");
	brand_placeholder = document.querySelector("[data_brand_placeholder");
	calc_opt = document.querySelector("#calc_opt");
	prod = document.querySelector("#calc_prod");

	constructor() {

		this.calc_opt.classList.add('hide');

		this.unite.addEventListener("change", () => {
			this.calcCubitFeet();
		});

		this.width.addEventListener("change", () => {
			this.calcCubitFeet();
		});

		this.height.addEventListener("change", () => {
			this.calcCubitFeet();
		});

		this.depth.addEventListener("change", () => {
			this.calcCubitFeet();
		});

		this.cubic_feet.addEventListener("change", () => {
			this.cubic_feet.classList.remove('error');
		});

		this.cubic_feet.addEventListener("keyup", () => {
			this.cubic_feet.classList.remove('error');
		});

		this.button.addEventListener("click", () => {
			this.calcHeat();
		});

		document.querySelector(".res-close").addEventListener("click", () => {
			this.calc_opt.classList.add('hide');
			this.prod.classList.remove('hide');

            var elmntToView = document.getElementById("calc_opt");
          
            const width = window.innerWidth;
          
            if (width <= 991) {
              elmntToView.scrollIntoView({
                behavior: 'smooth',  // Enables smooth scrolling
                block: 'start',      // Scrolls to the top of the element
                inline: 'nearest'    // Scrolls horizontally (if needed)
              });
            } 
		});
      
	}

	calcHeat() {
		this.cubic_feet.classList.remove('error');

		if (isNaN(this.getCubitFeet()) === true || this.getCubitFeet() < 1) {
			this.cubic_feet.focus();
			this.cubic_feet.classList.add('error');
			return;
		}

		let start = 0;
		let getBrandValue = this.getBrandValue();
		if (isNaN(this.getCold()) === false || this.getCold() >= 1) {
			let feet = this.getCold() * getBrandValue;
			start = (this.getCubitFeet() + feet) / 50;
		} else {
			start = (this.getCubitFeet()) / 50;
		}

		start = this.roundToNearestHalf(start);

		let end = parseFloat(start) + 3;

		let title = this.getTitle().replace('{{start}}', start.toLocaleString());

		this.title_placeholder.innerHTML = title.replace('{{end}}', end.toLocaleString());
		this.brand_placeholder.innerHTML = this.getBrandName().replace('{{brand}}', this.getSelectedBrandName());
		this.brand_placeholder.href = this.getBrandLink();

		this.calc_opt.classList.remove('hide');
		this.prod.classList.add('hide');

        var elmntToView = document.getElementById("calc_opt");
      
        const width = window.innerWidth;
      
        if (width <= 991) {
            elmntToView.scrollIntoView({
              behavior: 'smooth',  // Enables smooth scrolling
              block: 'start',      // Scrolls to the top of the element
              inline: 'nearest'    // Scrolls horizontally (if needed)
            });
        } 
      
	}

	calcCubitFeet() {

		this.cubic_feet.classList.remove('error');
		this.unite_calc = 0;

		this.unite_calc = this.getWidth() * this.getHeight() * this.getDepth();

		if (this.getWidth() < 1 || this.getHeight() < 1 || this.getDepth() < 1) {
			return false;
		}

		if (this.getUnite() === 'in') {
			this.unite_calc = this.getWidth() / 12 * this.getHeight() / 12 * this.getDepth() / 12;
		}
		this.cubic_feet.value = this.unite_calc % 1 === 0 ? this.unite_calc : this.unite_calc.toFixed(2);

	}

	getUnite() {
		return document.querySelector("[name='unite']:checked").attributes.value.value;
	}

	getWidth() {
		return parseInt(this.width.value);
	}

	getHeight() {
		return parseInt(this.height.value);
	}

	getDepth() {
		return parseInt(this.depth.value);
	}

	getCubitFeet() {
		return parseInt(this.cubic_feet.value);
	}

	getCold() {
		return parseInt(this.cold_sf_ft.value);
	}

	getBrand() {
		return document.querySelector("[name='brand']:checked");
	}

	getSelectedBrandName() {
		return this.brand.attributes.data_title.value;
	}

	getBrandValue() {
		this.brand = this.getBrand();
		return parseFloat(this.brand.attributes.value.value);
	}

	getBrandLink() {
		return this.brand.attributes.data_link.value;
	}

	getTitle() {
		return this.title_placeholder.attributes.data_title_placeholder.value;
	}

	getBrandName() {
		return this.brand_placeholder.attributes.data_brand_placeholder.value;
	}

	roundToNearestHalf(num) { return Math.round(num * 2) / 2; }
}

new HeatCalculator();